
import moment from "moment";
import { ActionContext } from "vuex";
import { ProductStateInterface } from "./types";
import Product from "@/types/app/products";
import store from "@/store";

moment.locale("en-US");
export default {  
  setProductSent(
    store: ActionContext<ProductStateInterface, any>,
    show: boolean
  ) {
    store.commit("setProductSent", show);
  },
  setModalProductState(
    store: ActionContext<ProductStateInterface, any>,
    show: any
  ) {
    store.commit("setModalProductState", show);
  },
  addNewProduct(
    store: ActionContext<ProductStateInterface, any>,
    product: Product
  ) {
    store.commit("addNewProduct", product);
  },
  removeProduct(
    store: ActionContext<ProductStateInterface, any>,
    id: string
  ) {
    store.commit("removeProduct", id);
  },
  setProductsState(
    store: ActionContext<ProductStateInterface, any>,
    products: Product[]
  ) {
    store.commit("setProductsState", products);
  },
  
};
